import apiClient from './client';
import type { Comment, CreateCommentPayload, UpdateCommentPayload } from '@/types/comment.types';

export const commentsApi = {
  listByNode: async (nodeId: string): Promise<Comment[]> => {
    const { data } = await apiClient.get<Comment[]>('/comments', {
      params: { nodeId },
    });
    return data;
  },

  create: async (payload: CreateCommentPayload): Promise<Comment> => {
    const { data } = await apiClient.post<Comment>('/comments', payload);
    return data;
  },

  update: async (commentId: string, payload: UpdateCommentPayload): Promise<Comment> => {
    const { data } = await apiClient.patch<Comment>(`/comments/${commentId}`, payload);
    return data;
  },

  delete: async (commentId: string): Promise<void> => {
    await apiClient.delete(`/comments/${commentId}`);
  },
};

export default commentsApi;
